import styled from '@emotion/styled'

type StyledPercentProps = {
  pnl: 'profit' | 'loss' | 'neutral'
  width?: string
}

const colors = {
  profit: 'var(--Success)',
  loss: 'var(--Red-Dark)',
  neutral: 'var(-Graphite)'
}

export const StyledPercent = styled.span<StyledPercentProps>`
  color: ${props => colors[props.pnl]};
  ${props => (props.width ? `width: ${props.width}` : '')}
`

export type PercentProps = {
  fixed?: boolean
  highlightPnl?: boolean
  numDecimalPlaces?: number
  value: number
  width?: string
}

function toPercentage(value: number, numDecimalPlaces: number, fixed: boolean) {
  if (fixed) {
    return value.toFixed(numDecimalPlaces)
  }

  // Wondering what the + is for?
  // See: https://stackoverflow.com/questions/11832914/how-to-round-to-at-most-2-decimal-places-if-necessary
  return (+value.toFixed(numDecimalPlaces)).toString()
}

export const Percent = ({ fixed, highlightPnl, numDecimalPlaces, value, width }: PercentProps) => {
  if (value === undefined || value === null) {
    return <>-</>
  }

  let formattedValue = value?.toString() || '0'

  if (numDecimalPlaces !== undefined) {
    formattedValue = toPercentage(value, numDecimalPlaces, fixed)
  }

  if (!highlightPnl || value === 0) {
    return (
      <StyledPercent pnl="neutral" width={width}>
        {formattedValue}%
      </StyledPercent>
    )
  }

  if (value > 0) {
    return (
      <StyledPercent pnl="profit" width={width}>
        {formattedValue}%
      </StyledPercent>
    )
  }

  return (
    <StyledPercent pnl="loss" width={width}>
      {formattedValue}%
    </StyledPercent>
  )
}
